<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.p1" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.p2" presetName="paragraph" />
    <email-text [contents]="data.p3" presetName="paragraph" />
    <email-margin [height]="28" />
    <email-text [contents]="data.p4" presetName="paragraph" />
    <email-margin [height]="28" />
    <hr />
    <email-margin [height]="28" />
    <email-text [contents]="data.p5_html" presetName="paragraph" className="web-rt-contains-link" />
    <email-margin [height]="28" />
    <email-button [label]="data.stop_label" [href]="data.stop_url" theme="danger" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
